/* DRUM TOASTER face: a web port of ToasterEditor::paint (dbfx-proto
   src/toaster/ToasterEditor.cpp, v0.6.10). Same 1200x900 artboard, same static
   scene (assets/toaster_bg3.png -> dt-face-bg.png), same moving parts drawn with
   the same paths, transforms, colours and timing. Keep in step with the C++ when
   the face changes. Exposes window.DTFace(canvas, opts). */
(function () {
  // ---- palette (ToasterEditor.cpp) ----
  var INK = [42, 39, 36], BONE = [240, 237, 225], CHERRY = [176, 58, 48], AMBER = [224, 160, 64], DOTSEL = [255, 253, 246];
  function hex(h) { return [(h >> 16) & 255, (h >> 8) & 255, h & 255]; }
  function mixC(a, b, k) { k = Math.min(1, Math.max(0, k)); return [a[0] + (b[0] - a[0]) * k, a[1] + (b[1] - a[1]) * k, a[2] + (b[2] - a[2]) * k]; }
  function css(c, a) { return 'rgba(' + Math.round(c[0]) + ',' + Math.round(c[1]) + ',' + Math.round(c[2]) + ',' + (a == null ? 1 : a) + ')'; }
  function darker(c, amt) { var k = 1 / (1 + amt); return [c[0] * k, c[1] * k, c[2] * k]; }
  function jmap(v, a, b, c, d) { return c + (v - a) / (b - a) * (d - c); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  var rad = function (d) { return d * Math.PI / 180; };

  // ---- JUCE AffineTransform: [m00, m01, m02, m10, m11, m12] ----
  function T(a, b, c, d, e, f) { return [a, b, c, d, e, f]; }
  var I = T(1, 0, 0, 0, 1, 0);
  function then(m, n) { // m followedBy n
    return [n[0] * m[0] + n[1] * m[3], n[0] * m[1] + n[1] * m[4], n[0] * m[2] + n[1] * m[5] + n[2],
            n[3] * m[0] + n[4] * m[3], n[3] * m[1] + n[4] * m[4], n[3] * m[2] + n[4] * m[5] + n[5]];
  }
  function tr(x, y) { return T(1, 0, x, 0, 1, y); }
  function sc(s) { return T(s, 0, 0, 0, s, 0); }
  function rot(r, px, py) {
    var c = Math.cos(r), s = Math.sin(r), m = T(c, -s, 0, s, c, 0);
    return px == null ? m : then(then(tr(-px, -py), m), tr(px, py));
  }
  function ap(m, x, y) { return [m[0] * x + m[1] * y + m[2], m[3] * x + m[4] * y + m[5]]; }
  function inv(m) {
    var det = m[0] * m[4] - m[1] * m[3];
    var a = m[4] / det, b = -m[1] / det, d = -m[3] / det, e = m[0] / det;
    return [a, b, -(a * m[2] + b * m[5]), d, e, -(d * m[2] + e * m[5])];
  }

  var svgT = then(then(tr(-107.5, -70), sc(1.12)), tr(458, 6));
  var leverT = then(T(0.8976, 0, 486.7, -0.4409, 1, 531.8), svgT);
  var bypassT = then(T(0.9233, 0, 168.2, 0.3836, 1, 399.4), svgT);
  var iso1 = then(T(0.9233, 0, 257.3, 0.3836, 1, 386.6), svgT);
  var iso2 = then(T(0.9233, 0, 357.6, 0.3836, 1, 337.3), svgT);

  // ---- path builder: points are transformed, so stroke widths stay in artboard px (as JUCE) ----
  function P(m) { this.m = m || I; this.p = new Path2D(); }
  P.prototype.mv = function (x, y) { var q = ap(this.m, x, y); this.p.moveTo(q[0], q[1]); return this; };
  P.prototype.ln = function (x, y) { var q = ap(this.m, x, y); this.p.lineTo(q[0], q[1]); return this; };
  P.prototype.qd = function (cx, cy, x, y) { var a = ap(this.m, cx, cy), b = ap(this.m, x, y); this.p.quadraticCurveTo(a[0], a[1], b[0], b[1]); return this; };
  P.prototype.cb = function (x1, y1, x2, y2, x, y) { var a = ap(this.m, x1, y1), b = ap(this.m, x2, y2), c = ap(this.m, x, y); this.p.bezierCurveTo(a[0], a[1], b[0], b[1], c[0], c[1]); return this; };
  P.prototype.cl = function () { this.p.closePath(); return this; };
  var K = 0.5523;
  P.prototype.rr = function (x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2); var k = r * K;
    return this.mv(x + r, y).ln(x + w - r, y).cb(x + w - r + k, y, x + w, y + r - k, x + w, y + r)
      .ln(x + w, y + h - r).cb(x + w, y + h - r + k, x + w - r + k, y + h, x + w - r, y + h)
      .ln(x + r, y + h).cb(x + r - k, y + h, x, y + h - r + k, x, y + h - r)
      .ln(x, y + r).cb(x, y + r - k, x + r - k, y, x + r, y).cl();
  };
  P.prototype.el = function (x, y, w, h) {
    var rx = w / 2, ry = h / 2, cx = x + rx, cy = y + ry, kx = rx * K, ky = ry * K;
    return this.mv(cx, y).cb(cx + kx, y, x + w, cy - ky, x + w, cy).cb(x + w, cy + ky, cx + kx, y + h, cx, y + h)
      .cb(cx - kx, y + h, x, cy + ky, x, cy).cb(x, cy - ky, cx - kx, y, cx, y).cl();
  };

  function slotIn(ax) {
    var o = new P(svgT);
    if (ax === 1) o.mv(243.6, 397.5).ln(484.6, 497.7).qd(493.8, 501.5, 502.8, 497.1).ln(530.4, 483.5).qd(539.4, 479.1, 530.2, 475.3)
      .ln(289.2, 375.1).qd(280.0, 371.3, 271.0, 375.7).ln(243.4, 389.3).qd(234.4, 393.7, 243.6, 397.5).cl();
    else o.mv(343.9, 348.2).ln(584.9, 448.4).qd(594.1, 452.2, 603.1, 447.8).ln(630.7, 434.2).qd(639.7, 429.8, 630.5, 426.0)
      .ln(389.5, 325.8).qd(380.3, 322.0, 371.3, 326.4).ln(343.7, 340.0).qd(334.7, 344.4, 343.9, 348.2).cl();
    return o.p;
  }
  var SLOT1 = slotIn(1), SLOT2 = slotIn(2);
  var LIP1 = new P(svgT).mv(243.6, 397.5).ln(484.6, 497.7).qd(493.8, 501.5, 502.8, 497.1).p;
  var LIP2 = new P(svgT).mv(343.9, 348.2).ln(584.9, 448.4).qd(594.1, 452.2, 603.1, 447.8).p;

  var SMOKE = [0, 1, 2, 3].map(function (i) {
    var sx = [1.05, 0.76, 0.52, 0.70][i], tx = [428, 513, 594, 452][i], ty = [262, 296, 340, 160][i];
    var o = new P(then(then(sc(sx), tr(tx, ty)), svgT));
    if (i === 0) o.mv(13, 83).cb(27, 68, 1, 60, 7, 47).cb(11, 39, 13, 38, 0, 30);
    else if (i === 1) o.mv(13, 116).cb(28, 96, 0, 86, 7, 66).cb(12, 50, 14, 44, 0, 30);
    else if (i === 2) o.mv(13, 146).cb(28, 120, 0, 108, 7, 82).cb(12, 58, 14, 48, 0, 30);
    else o.mv(13, 89).cb(27, 74, 1, 64, 7, 50).cb(11, 40, 13, 39, 0, 30);
    o.cb(-16.6, 30, -31, 17.1, -31, 0).cb(-31, -17.1, -16.6, -30, 0, -30).cb(16.6, -30, 28, -15.5, 28, 0)
     .cb(28, 9.4, 9.4, 17, 0, 17).cb(-9.4, 17, -12, 6.6, -12, 0).cb(-12, -6.6, -2.8, -5, 0, -5);
    return o.p;
  });

  // ---- bread browning per flavor (breadColour) ----
  var MID = [0xEACB6E, 0xF0A122, 0xC25B66, 0x9A8C7C].map(hex);
  var TOASTED = [0xD9A845, 0xE08A0E, 0x9C3A4C, 0x5A5048].map(hex);
  var BURNT = [0xA9772F, 0xB35F06, 0x5E2430, 0x2E2A26].map(hex);
  var PALE = hex(0xF3E7C9);
  function breadColour(f, t) {
    if (t < 0.5) return mixC(PALE, MID[f], t / 0.5 * 0.85);
    if (t < 0.8) return mixC(MID[f], TOASTED[f], (t - 0.5) / 0.3);
    return mixC(TOASTED[f], BURNT[f], (t - 0.8) / 0.2);
  }
  function toastCurve(v) { v = clamp(v, 0, 1); return v < 0.8 ? 0.65 * (v / 0.8) : 0.65 + 0.35 * ((v - 0.8) / 0.2); }

  var FLAV = { x: 55, y: 284, w: 288, h: 58, step: 74 };
  var NAMES = ['BUTTER', 'HONEY', 'JAM', 'CHARRED'];
  var LEVER_Y0 = 21, LEVER_TRAVEL = 180;
  var CHIP = [1079, 45, 87, 33];

  function DTFace(canvas, o) {
    var ctx = canvas.getContext('2d');
    var bg = new Image(); bg.src = o.bg;
    // v1.0.0 face: the Db. logo where "Db. FX" stood; no version chip on the web, so the logo takes the chip's right edge
    var logo = new Image(); if (o.logo) logo.src = o.logo;
    var LOGO_H = 36, LOGO_W = 36 * 800 / 581, LOGO = [CHIP[0] + CHIP[2] - LOGO_W, 40.8, LOGO_W, LOGO_H];
    var st = { out: 0.5, lever: o.lever == null ? 0 : o.lever, flavor: 0, bypass: false, extra: false, extraOk: true, enabled: [true, true, false, true],
               phase: 0, lamp: 0, version: o.version || 'V0.6.10' };
    var dpr = 1, W = 0;

    function size() {
      dpr = Math.min(window.devicePixelRatio || 1, 2.5);
      W = canvas.clientWidth;
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(W * 0.75 * dpr);
    }

    function text(s, x, y, w, h, px, ls, weight, align) {
      ctx.font = (weight || 400) + ' ' + px + 'px Jost, sans-serif';
      if ('letterSpacing' in ctx) ctx.letterSpacing = ls + 'px';
      ctx.textBaseline = 'middle';
      ctx.textAlign = align === 'left' ? 'left' : 'center';
      ctx.fillText(s, align === 'left' ? x : x + w / 2, y + h / 2 + 1);
      if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
    }
    function stroke(p, w, c) { ctx.lineWidth = w; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.strokeStyle = c; ctx.stroke(p); }

    function paint() {
      if (!W) size();
      var lever = st.lever, t = toastCurve(lever), byp = st.bypass, f = st.flavor, ex = st.extra;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var s = canvas.width / 1200;
      ctx.setTransform(s, 0, 0, s, 0, 0);
      if (bg.complete && bg.naturalWidth) ctx.drawImage(bg, 0, 0, 1200, 900);
      else { ctx.fillStyle = css(BONE); ctx.fillRect(0, 0, 1200, 900); }

      // slot embers
      if (!byp && t > 0.30) {
        // EXTRA: flicker faster and deeper, colour pushed toward cherry (as the C++)
        var a0 = (t - 0.30) / 0.70, ph = st.phase;
        var flick = 1 + (ex ? 0.17 : 0.10) * Math.sin(ph * (ex ? 14.7 : 7.1)) + (ex ? 0.10 : 0.06) * Math.sin(ph * (ex ? 33.9 : 17.3) + 1.2);
        var a = clamp(a0 * (ex ? 0.95 : 0.85) * flick, 0, 1);
        ctx.fillStyle = css(mixC(AMBER, CHERRY, ex ? Math.min(1, a0 * 1.6 + 0.25) : a0), a);
        ctx.fill(SLOT1); ctx.fill(SLOT2);
      }

      // toast slices
      var pop = jmap(lever, 0, 1, 100, 40), bread = breadColour(f, byp ? 0 : t);
      function slice(M, extra) {
        var x0 = 40, x1 = 240, mid = 140, top = -(pop + extra), bot = 6;
        function body(m) {
          return new P(m).mv(x0, bot).ln(x0, top + 44).qd(x0, top, x0 + 52, top).qd(mid - 24, top, mid, top + 16)
            .qd(mid + 24, top, x1 - 52, top).qd(x1, top, x1, top + 44).ln(x1, bot).cl().p;
        }
        var back = body(then(M, tr(9.6, -7.7))), front = body(M);
        ctx.fillStyle = css(darker(bread, 0.18)); ctx.fill(back); stroke(back, 3, css(INK));
        ctx.fillStyle = css(bread); ctx.fill(front); stroke(front, 3, css(INK));
        var c = new P(M).mv(x0 + 10, bot).ln(x0 + 10, top + 46).qd(x0 + 10, top + 10, x0 + 54, top + 10)
          .qd(mid - 22, top + 10, mid, top + 26).qd(mid + 22, top + 10, x1 - 54, top + 10)
          .qd(x1 - 10, top + 10, x1 - 10, top + 46).ln(x1 - 10, bot).p;
        stroke(c, 1.75, css(INK, 0.40));
      }
      slice(iso2, 12); stroke(LIP2, 3, css(INK));
      slice(iso1, 0); stroke(LIP1, 3, css(INK));

      // smoke
      if (!byp) {
        var thresh = [0.12, 0.32, 0.52, 0.72], period = [2.6, 3.1, 2.2, 2.9], offset = [0, 0.8, 1.6, 0.4];
        for (var i = 0; i < 4; i++) {
          var pres = clamp((t - (ex ? 0.12 : thresh[i])) / 0.15, 0, 1);   // EXTRA: all four curls, quicker, higher
          if (pres < 0.01) continue;
          var per = period[i] * (ex ? 0.75 : 1), cyc = ((st.phase + offset[i]) % per) / per;
          var env = cyc < 0.15 ? cyc / 0.15 : 1 - (cyc - 0.15) / 0.85;
          var dx = (ex ? 4 : 2.5) * Math.sin(cyc * Math.PI * 2) + (ex ? 1.2 * Math.sin(cyc * 5.1 * Math.PI * 2 + i) : 0);
          ctx.save(); ctx.translate(dx, (ex ? -34 : -26) * cyc);
          stroke(SMOKE[i], ex ? 3.2 : 3, css(INK, (ex ? 0.60 : 0.55) * pres * env)); ctx.restore();
        }
      }

      // lever: amber track + handle
      var ly = LEVER_Y0 + lever * LEVER_TRAVEL;
      var fill = new P(leverT).rr(97, 27, 11, Math.max(0, ly + 17 - 27), 5.5).p;
      var pulse = byp ? 0 : clamp(st.lamp, 0, 1);
      if (pulse > 0.04) { ctx.lineWidth = 7; ctx.strokeStyle = css(AMBER, 0.35 * pulse); ctx.stroke(fill); }
      ctx.fillStyle = css(mixC(AMBER, hex(0xFFCF78), 0.85 * pulse)); ctx.fill(fill);
      var c0 = ap(leverT, 102.5, ly + 17), hs = 1.35;
      var place = then(then(then(tr(-32, -20), rot(rad(-17))), sc(hs)), tr(c0[0], c0[1]));
      var r7 = rad(-7);
      function plate(x, y) { return new P(then(rot(r7, x, y), place)).rr(x, y, 53.7867, 22.681, 7.75).p; }
      var pb = plate(1.393, 8.5798), pf = plate(7.1704, 13.0937);
      ctx.fillStyle = css(BONE); ctx.fill(pb); ctx.lineWidth = 2.5 * hs; ctx.strokeStyle = css(INK); ctx.lineCap = 'butt'; ctx.lineJoin = 'miter'; ctx.stroke(pb);
      var edges = new P(place).mv(4.33, 27.62).ln(11.33, 33.62).mv(52.30, 3.60).ln(60.30, 9.60).mv(3.29, 10.59).ln(10.29, 15.59).p;
      ctx.lineWidth = 1.2 * hs; ctx.stroke(edges);
      ctx.fillStyle = css(BONE); ctx.fill(pf); ctx.lineWidth = 2.5 * hs; ctx.stroke(pf);
      var ribs = new P(place).mv(21.78, 24.96).ln(20.20, 11.72).mv(34.27, 23.43).ln(32.70, 10.19).mv(46.77, 21.89).ln(45.20, 8.65).p;
      stroke(ribs, 2.5 * hs, css(INK));

      // flavor selection + veil on disabled
      for (i = 0; i < 4; i++) {
        var ry = FLAV.y + i * FLAV.step;
        if (i === f) {
          ctx.fillStyle = css(AMBER); ctx.fill(new P().rr(FLAV.x, ry, FLAV.w, FLAV.h, FLAV.h / 2).p);
          ctx.fillStyle = css(DOTSEL); ctx.fill(new P().el(FLAV.x + 27, ry + FLAV.h / 2 - 7.5, 15, 15).p);
          ctx.fillStyle = css(INK); text(NAMES[i], FLAV.x + 68, ry, FLAV.w - 72, FLAV.h, 25, 2.4, 400, 'left');
        } else if (!st.enabled[i]) {
          ctx.fillStyle = css(BONE, 0.55); ctx.fill(new P().rr(FLAV.x - 2, ry - 2, FLAV.w + 4, FLAV.h + 4, FLAV.h / 2 + 2).p);
        }
      }

      // knob needles (input/output at 0 dB)
      function needle(cx, cy, v) {
        var an = rad(-120 + v * 240), sn = Math.sin(an), co = Math.cos(an);
        stroke(new P().mv(cx + 7 * sn, cy - 7 * co).ln(cx + 32.7 * sn, cy - 32.7 * co).p, 3.07, css(INK));
      }
      needle(111, 754, 0.5); needle(267, 754, st.out);   // page: OUTPUT works (clean volume); INPUT is fixed at 0 dB

      // power icon
      function power(col) {
        var pw = new Path2D(); pw.arc(51, 62.7, 11, rad(42.3) - Math.PI / 2, rad(317.7) - Math.PI / 2);
        pw.moveTo(51, 49.6); pw.lineTo(51, 61.4); stroke(pw, 3.75, col);
      }
      power(byp ? css(CHERRY, 0.40) : css(CHERRY));

      // preset field, OS pill (4x), mix pointer (100%)
      ctx.fillStyle = css(INK); text('DEFAULT', 130, 44, 168, 36, 25, 3.6, 400, 'left');
      ctx.fillStyle = css(AMBER); ctx.fill(new P().rr(662, 43, 63, 38, 19).p);
      ctx.fillStyle = css(INK); text('2X', 599, 43, 63, 38, 21, 1.6); text('4X', 662, 43, 63, 38, 21, 1.6);
      var ma = rad(120);
      stroke(new P().mv(438 + 8 * Math.sin(ma), 56 - 8 * Math.cos(ma)).ln(438 + 16.5 * Math.sin(ma), 56 - 16.5 * Math.cos(ma)).p, 2.76, css(INK));

      // Db. logo (the plugin's 1.0.0 header)
      if (logo.complete && logo.naturalWidth) ctx.drawImage(logo, LOGO[0], LOGO[1], LOGO[2], LOGO[3]);

      // bypass dot + EXTRA ring
      var bdot = new P(bypassT).el(49, 173, 34, 34).p;
      if (byp) { ctx.fillStyle = css(CHERRY); ctx.fill(bdot); }
      var xdot = new P(bypassT).el(159, 173, 34, 34).p;
      if (ex) { ctx.fillStyle = css(AMBER); ctx.fill(xdot); }
      stroke(xdot, 3, css(INK));
      ctx.save(); ctx.transform(bypassT[0], bypassT[3], bypassT[1], bypassT[4], bypassT[2], bypassT[5]);
      ctx.fillStyle = css(INK); text('EXTRA', 116, 216, 120, 22, 19, 1.4); ctx.restore();

      // bypassed = powered down
      if (byp) {
        ctx.fillStyle = css(BONE, 0.50); ctx.fillRect(0, 0, 1200, 900);
        power(css(CHERRY)); ctx.fillStyle = css(CHERRY); ctx.fill(bdot);
      }
    }

    // ---- hit testing (artboard px), same zones as mouseDown, a little wider for fingers ----
    function toArt(e) {
      var r = canvas.getBoundingClientRect();
      return [(e.clientX - r.left) / r.width * 1200, (e.clientY - r.top) / r.height * 900];
    }
    var LINV = inv(leverT), BINV = inv(bypassT);
    function hit(x, y) {
      var lp = ap(LINV, x, y);
      if (lp[0] > 10 && lp[0] < 190 && lp[1] > -10 && lp[1] < 262) return { kind: 'lever' };
      for (var i = 0; i < 4; i++) {
        var ry = FLAV.y + i * FLAV.step;
        // the whole row counts (gap included, out to the divider): on a phone these pills are the only flavor buttons
        if (x >= FLAV.x - 20 && x <= FLAV.x + FLAV.w + 40 && y >= ry - 8 && y <= ry + FLAV.h + 8) return { kind: 'flavor', i: i };
      }
      var bp = ap(BINV, x, y);
      if (Math.hypot(bp[0] - 66, bp[1] - 190) < 34) return { kind: 'bypass' };
      if (x < 90 && y < 100) return { kind: 'bypass' };
      if (st.extraOk && Math.hypot(bp[0] - 176, bp[1] - 190) < 34) return { kind: 'extra' };
      if (Math.hypot(x - 267, y - 754) < 48) return { kind: 'output' };
      if (Math.hypot(x - 111, y - 754) < 48) return { kind: 'input' };
      // top bar: the plugin-only controls answer with a tip (phone-sized hit areas)
      if (Math.hypot(x - 438, y - 60) < 50) return { kind: 'mix' };
      if (x >= 520 && x <= 740 && y >= 28 && y <= 100) return { kind: 'os' };
      if (x >= 110 && x <= 340 && y >= 28 && y <= 100) return { kind: 'preset' };
      return null;
    }
    function leverFrom(x, y) { var lp = ap(LINV, x, y); return clamp((lp[1] - 17 - LEVER_Y0) / LEVER_TRAVEL, 0, 1); }

    var dragging = false, outDrag = null;
    canvas.addEventListener('pointerdown', function (e) {
      var q = toArt(e), h = hit(q[0], q[1]);
      if (!h) return;
      e.preventDefault();
      if (h.kind === 'lever') {
        dragging = true; canvas.setPointerCapture(e.pointerId);
        st.lever = leverFrom(q[0], q[1]); o.onLever && o.onLever(st.lever, true);
      } else if (h.kind === 'flavor') {
        if (st.enabled[h.i] && h.i !== st.flavor) { st.flavor = h.i; o.onFlavor && o.onFlavor(h.i); }
      } else if (h.kind === 'bypass') {
        st.bypass = !st.bypass; o.onBypass && o.onBypass(st.bypass);
      } else if (h.kind === 'extra') {
        st.extra = !st.extra; o.onExtra && o.onExtra(st.extra);
      } else if (h.kind === 'output') {
        outDrag = { y: q[1], v: st.out }; canvas.setPointerCapture(e.pointerId);
      } else if (h.kind === 'input' || h.kind === 'mix' || h.kind === 'os' || h.kind === 'preset') {
        o.onTip && o.onTip(h.kind);
      }
    });
    canvas.addEventListener('pointermove', function (e) {
      var q = toArt(e);
      if (dragging) { st.lever = leverFrom(q[0], q[1]); o.onLever && o.onLever(st.lever, false); return; }
      if (outDrag) { st.out = clamp(outDrag.v + (outDrag.y - q[1]) / 320, 0, 1); o.onOutput && o.onOutput(st.out); return; }
      var h = hit(q[0], q[1]);
      canvas.style.cursor = !h ? 'default' : (h.kind === 'lever' || h.kind === 'output') ? 'ns-resize' : (h.kind === 'flavor' && !st.enabled[h.i]) ? 'not-allowed' : 'pointer';
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) { canvas.addEventListener(ev, function () { dragging = false; outDrag = null; }); });
    canvas.addEventListener('dblclick', function (e) {
      var q = toArt(e), h = hit(q[0], q[1]);
      if (h && h.kind === 'output') { st.out = 0.5; o.onOutput && o.onOutput(st.out); }
    });
    canvas.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 0.1 : 0.02, v = st.lever;
      if (e.key === 'ArrowDown') v += step; else if (e.key === 'ArrowUp') v -= step;
      else if (e.key === 'Home') v = 0; else if (e.key === 'End') v = 1; else return;
      e.preventDefault(); st.lever = clamp(v, 0, 1); o.onLever && o.onLever(st.lever, false);
    });

    // ---- animation: phase in seconds (timerCallback adds 1/30 per 30 Hz tick) ----
    var last = 0, visible = true, raf = 0;
    function frame(ts) {
      var dt = last ? Math.min(0.1, (ts - last) / 1000) : 0; last = ts;
      st.phase += dt;
      var flash = o.flash ? o.flash() : 0;
      st.lamp = Math.max(flash, st.lamp * Math.pow(0.80, dt * 30));
      paint();
      raf = visible ? requestAnimationFrame(frame) : 0;
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible && !raf) { last = 0; raf = requestAnimationFrame(frame); }
      }).observe(canvas);
    }
    window.addEventListener('resize', function () { size(); paint(); });
    bg.onload = paint; logo.onload = paint;
    size();
    if (document.fonts && document.fonts.load) {
      Promise.all([document.fonts.load('400 25px Jost'), document.fonts.load('600 17px Jost')]).then(paint, paint);
    }
    raf = requestAnimationFrame(frame);

    return {
      state: st,
      setFlavor: function (i) { st.flavor = i; },
      setEnabled: function (arr) { st.enabled = arr; paint(); },
      setExtra: function (on) { st.extra = !!on; },
      setExtraOk: function (ok) { st.extraOk = !!ok; if (!ok) st.extra = false; },
      setLever: function (v) { st.lever = clamp(v, 0, 1); }
    };
  }
  window.DTFace = DTFace;
})();
